module.exports = __webpack_public_path__ + "img/ptyd.6efed5b3.png";